import { FC } from "react";
import {
  i18translateType,
  PagePropsBasicType,
} from "../../../@types/types-body";
import ContainerDividerSpanFirst from "@components/dividers/container-divider-span-first";
import { TeamCardIconImageTopWithoutLinks } from "@components/cards/team-card-icon-image-top-without-links";
import { useTranslation } from "next-i18next";
import { TeamMembers } from "@data/team";

const OurManagement: FC<PagePropsBasicType> = ({ namespace }) => {
  const { t }: i18translateType = useTranslation(namespace);
  return (
    <section className="my-24">
      <div className="container mx-auto">
        <ContainerDividerSpanFirst
          id={"our-management"}
          title={"our_management.title"}
          subtitle={"our_management.subtitle"}
          text={"our_management.text"}
          span={"our_management.span"}
          namespace={namespace}
        />
        <div className="grid gap-14 grid-cols-1 sm:grid-cols-2 justify-items-center place-content-center">
          {Object.keys(
            t("our_management.management", { returnObjects: true })
          ).map((object, index) => (
            <TeamCardIconImageTopWithoutLinks
              key={`service-card-for-${index}`}
              id={index}
              namespace={namespace}
              photo={TeamMembers[`${object}`]}
              name={`our_management.management.${object}.name`}
              cssPosition={object === "linda"}
              text={`our_management.management.${object}.description`}
              position={`our_management.management.${object}.position`}
              link={`common:menu.path.${object}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurManagement;
